'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _isNumber = require('lodash/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _howler = require('howler');

var _Player2 = require('../models/Player');

var _Player3 = _interopRequireDefault(_Player2);

var _htmlMediaEvents = require('../constants/htmlMediaEvents');

var _htmlMediaEvents2 = _interopRequireDefault(_htmlMediaEvents);

var _timeToPercentage = require('../utils/timeToPercentage');

var _timeToPercentage2 = _interopRequireDefault(_timeToPercentage);

var _playerName = require('../constants/playerName');

var _playerName2 = _interopRequireDefault(_playerName);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onError(callback, isFormatSupported) {
  return function (event, mediaErrorCode) {
    var eventType = (0, _get3.default)(event, 'type');
    var error = new Error(_playerName2.default.Howler + ' error');
    error.errorData = _constants.howlerErrorCodeMap[mediaErrorCode] || _constants.htmlMediaErrorMap[eventType] || (eventType ? { eventType: eventType } : {});
    // format errors are also considered network errors by players, so we'll use this flag to
    // allow logging of potential formatting compatibility issues
    error.errorData.isFormatError = !isFormatSupported;
    return callback(error);
  };
}

var Howler = function (_Player) {
  (0, _inherits3.default)(Howler, _Player);
  (0, _createClass3.default)(Howler, null, [{
    key: 'loadAndPlayOnce',
    value: function loadAndPlayOnce(blankMP3Url) {
      Howler.isPlayerPrimed = true;
      var sound = new _howler.Howl({ src: [blankMP3Url] });
      sound.play();
    }
  }]);

  function Howler(blankMP3Url) {
    var _this$howlerEventsMap, _this$htmlMediaEvents;

    (0, _classCallCheck3.default)(this, Howler);

    // By optimistically loading and playing a blank MP3 file on first player instantiation,
    // we're able to circumvent an unexpected iOS browser behavior that occasionally blocks
    // audio playback when the user's first interaction is the play button. The execution load is
    // insignificant enough that we can execute this on any device, just to be safe.
    var _this = (0, _possibleConstructorReturn3.default)(this, (Howler.__proto__ || (0, _getPrototypeOf2.default)(Howler)).call(this, _playerName2.default.Howler));

    if (!Howler.isPlayerPrimed) {
      Howler.loadAndPlayOnce(blankMP3Url);
    }

    _this.howlerEventsMap = (_this$howlerEventsMap = {}, (0, _defineProperty3.default)(_this$howlerEventsMap, _htmlMediaEvents2.default.seeked, _constants.howlerEvents.seek), (0, _defineProperty3.default)(_this$howlerEventsMap, _htmlMediaEvents2.default.play, _constants.howlerEvents.play), (0, _defineProperty3.default)(_this$howlerEventsMap, _htmlMediaEvents2.default.ended, _constants.howlerEvents.end), (0, _defineProperty3.default)(_this$howlerEventsMap, _htmlMediaEvents2.default.error, _constants.howlerEvents.playerror), _this$howlerEventsMap);

    _this.htmlMediaEventsMap = (_this$htmlMediaEvents = {}, (0, _defineProperty3.default)(_this$htmlMediaEvents, _htmlMediaEvents2.default.progress, _htmlMediaEvents2.default.progress), (0, _defineProperty3.default)(_this$htmlMediaEvents, _htmlMediaEvents2.default.timeupdate, _htmlMediaEvents2.default.timeupdate), (0, _defineProperty3.default)(_this$htmlMediaEvents, _htmlMediaEvents2.default.stalled, _htmlMediaEvents2.default.stalled), _this$htmlMediaEvents);
    return _this;
  }

  (0, _createClass3.default)(Howler, [{
    key: 'on',
    value: function on(event, callback) {
      var howlerEvent = this.howlerEventsMap[event];

      if (howlerEvent === _constants.howlerEvents.playerror) {
        this.cachedErrorCallback = onError(callback, this.isFormatSupported);
        this.howler.on(howlerEvent, this.cachedErrorCallback);
        return;
      }

      if (howlerEvent) {
        this.howler.on(howlerEvent, callback);
        return;
      }

      if (this.htmlMediaEventsMap[event]) {
        this.howlerNode.addEventListener(event, callback);
      }
    }
  }, {
    key: 'off',
    value: function off(event, callback) {
      var howlerEvent = this.howlerEventsMap[event];

      if (howlerEvent === _constants.howlerEvents.playerror) {
        this.howler.off(howlerEvent, this.cachedErrorCallback);
        delete this.cachedErrorCallback;
        return;
      }

      if (howlerEvent) {
        this.howler.off(howlerEvent, callback);
        return;
      }

      if (this.htmlMediaEventsMap[event]) {
        this.howlerNode.removeEventListener(event, callback);
      }
    }

    /**
     * This is necessary on Safari mobile and desktop browsers due to autoplay restrictions.
     * See PlayerLoader.js for more details.
     * @param blankMp3Url {string}
     */

  }, {
    key: 'preload',
    value: function preload(blankMp3Url) {
      this.howler = new _howler.Howl({ src: [blankMp3Url] });
      this.howler.play();
    }
  }, {
    key: 'load',
    value: function load(url, format) {
      var _this2 = this;

      // unloads and destroys any existing Howler players, including instances created by preload()
      _howler.Howler.unload();

      return new _promise2.default(function (resolve, reject) {
        _this2.isFormatSupported = !!_howler.Howler.codecs(format);

        if (!_this2.isFormatSupported) {
          return onError(reject, _this2.isFormatSupported)();
        }

        _this2.howler = new _howler.Howl({ src: [url], format: [format], html5: true });

        _this2.howler.once(_constants.howlerEvents.load, resolve);
        _this2.howler.once(_constants.howlerEvents.loaderror, onError(reject, _this2.isFormatSupported));
      });
    }
  }, {
    key: 'play',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(playPosition) {
        var _this3 = this;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new _promise2.default(function (resolve, reject) {
                  _this3.howler.once(_constants.howlerEvents.play, resolve);
                  _this3.howler.once(_constants.howlerEvents.playerror, onError(reject, _this3.isFormatSupported));

                  if (playPosition) {
                    _this3.howler.seek(playPosition);
                  }

                  _this3.howler.play();
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function play(_x) {
        return _ref.apply(this, arguments);
      }

      return play;
    }()
  }, {
    key: 'seek',
    value: function seek(position) {
      if (this.howler) {
        this.howler.seek(position / 100 * this.howler.duration());
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      if (this.howler) {
        this.howler.pause();
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this.howler) {
        this.howler.stop();
      }
    }
  }, {
    key: 'canChangePlaybackRate',
    value: function canChangePlaybackRate() {
      return !!(this.howler && this.howler.rate());
    }
  }, {
    key: 'getPlaybackRate',
    value: function getPlaybackRate() {
      return this.howler ? this.howler.rate() : 1.0;
    }
  }, {
    key: 'changePlaybackRate',
    value: function changePlaybackRate(rate) {
      if (this.howler) {
        this.howler.rate(rate);
      }
    }
  }, {
    key: 'unload',
    value: function unload() {
      if (this.howler) {
        this.howler.unload();
      } else {
        _howler.Howler.unload();
      }
    }

    // Howler doesn't provide a dedicated destroy method, but its unload method unloads and destroys

  }, {
    key: 'destroy',
    value: function destroy() {
      this.unload();
    }
  }, {
    key: 'setVolume',
    value: function setVolume(volume) {
      if (this.howler && (0, _isNumber2.default)(volume)) {
        this.howler.volume(volume / 100);
      }
    }
  }, {
    key: 'getVolume',
    value: function getVolume() {
      return this.howler ? this.howler.volume() : 0;
    }
  }, {
    key: 'getTimes',
    value: function getTimes() {
      var duration = this.howler ? this.howler.duration() : 0;
      var elapsedSeconds = this.howler ? this.howler.seek() : 0;

      return {
        duration: Math.floor(duration),
        elapsedSeconds: Math.floor(elapsedSeconds),
        elapsedPercent: (0, _timeToPercentage2.default)(elapsedSeconds, duration)
      };
    }
  }, {
    key: 'howlerNode',
    get: function get() {
      return (0, _get3.default)(this.howler, '_sounds[0]._node', _constants.howlerNodeStub);
    }
  }]);
  return Howler;
}(_Player3.default);

Howler.isPlayerPrimed = false;
exports.default = Howler;
//# sourceMappingURL=Howler.js.map